import { AddDeliveryZoneRequestBody } from "../apis";
import { DeliveryFeeFormValues } from "../components/forms";

export const getAddDeliveryZoneRequestBody = (
  formValues: DeliveryFeeFormValues
): AddDeliveryZoneRequestBody => {
  return {
    country: String(formValues.country),
    city: String(formValues.city),
    neighborhood: String(formValues.neighborhood),
    isExpedition: formValues.isExpedition,
    isHiddenFromResellers: formValues.isHiddenFromResellers,
    allowedResellerIds: formValues.allowedResellerIds,
    fee: {
      sizeSFee: +formValues.sizeSFee,
      sizeMFee: +formValues.sizeMFee,
      sizeLFee: +formValues.sizeLFee,
      allowCashOnDelivery: formValues.allowCashOnDelivery,
      allowMobileMoney: formValues.allowMobileMoney
    }
  };
};
